<template>
  <div class="my-page-container">
    <!-- 未登录状态展示 -->
    <div v-if="!loginUser" class="not-login-wrap" @click="handleLogin">
      <div class="default-avatar">
        <i class="el-icon-user" />
      </div>
      <div class="login-tip">
        <h3>点击登录</h3>
        <p>登录后即可同步全网精彩视频</p>
      </div>
    </div>

    <!-- 已登录状态展示 -->
    <template v-else>
      <!-- 1. 用户资料主卡片 -->
      <div class="user-profile-header">
        <div class="user-main-info" @click="goToSpace">
          <img :src="loginUser.avatarUrl" class="avatar" alt="avatar">
          <div class="info-detail">
            <div class="name-row">
              <span class="nickname">{{ loginUser.screenName }}</span>
              <i class="el-icon-edit edit-icon" @click.stop="$message.info('编辑资料')" />
              <span class="vip-tag">正式会员</span>
            </div>
            <div class="coin-row">
              <span>B币: 0.0</span>
              <span class="divider">·</span>
              <span>硬币: 3144</span>
            </div>
          </div>
          <div class="space-link">
            <span>空间</span>
            <i class="el-icon-arrow-right" />
          </div>
        </div>

        <!-- 动态 / 关注 / 粉丝 统计行 -->
        <div class="stats-row">
          <div class="stat-item" @click="$message.info('动态')">
            <span class="num">0</span>
            <span class="label">动态</span>
          </div>
          <div class="stat-divider" />
          <div class="stat-item" @click="$message.info('关注')">
            <span class="num">9</span>
            <span class="label">关注</span>
          </div>
          <div class="stat-divider" />
          <div class="stat-item" @click="$message.info('粉丝')">
            <span class="num">0</span>
            <span class="label">粉丝</span>
          </div>
        </div>
      </div>

      <!-- 2. 大会员引导横幅 (根据 isVip 动态显示) -->
      <div v-if="!isVip" class="vip-banner-card" @click="goToWallet">
        <div class="vip-left">
          <div class="vip-icon-box">
            <i class="el-icon-star-on" />
          </div>
          <div class="vip-text">
            <h4>开通大会员</h4>
            <p>了解更多权益 <i class="el-icon-arrow-right" /></p>
          </div>
        </div>
        <div class="vip-right">
          <span class="open-btn">立即开通</span>
          <i class="el-icon-arrow-right" />
        </div>
      </div>

      <!-- 3. 快捷功能网格入口 -->
      <div class="quick-grid-section" :class="{ 'no-banner-margin': isVip }">
        <div class="grid-item" @click="goToHistory">
          <i class="el-icon-time" />
          <span>历史记录</span>
        </div>
        <div class="grid-item" @click="goToPlaylist">
          <i class="el-icon-star-off" />
          <span>我的收藏</span>
        </div>
        <div class="grid-item" @click="goToWatchLater">
          <i class="el-icon-video-camera" />
          <span>稍后再看</span>
        </div>
      </div>

      <!-- 4. 更多服务列表 -->
      <div class="more-service-section">
        <div class="section-title">更多服务</div>

        <div class="service-list">
          <div class="service-item" @click="goToWallet">
            <div class="item-left">
              <i class="el-icon-wallet" style="color: #ff5722;" />
              <span>我的钱包</span>
            </div>
            <i class="el-icon-arrow-right arrow" />
          </div>

          <div class="service-item" @click="openSettings">
            <div class="item-left">
              <i class="el-icon-setting" style="color: #757575;" />
              <span>设置</span>
            </div>
            <i class="el-icon-arrow-right arrow" />
          </div>
        </div>
      </div>
    </template>

    <!-- 设置弹窗 -->
    <el-dialog
      title="系统设置"
      :visible.sync="showSettingsDialog"
      width="85%"
      center
      custom-class="mobile-dialog"
      append-to-body
    >
      <div class="setting-item-row">
        <span>开启精选推荐</span>
        <el-switch v-model="modeEnabled" @change="onChange" />
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" @click="showSettingsDialog = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserRcmd, setUserRcmd } from '@/api/vod'

export default {
  name: 'MyPageMobile',
  data() {
    return {
      isVip: false,
      showSettingsDialog: false,
      modeEnabled: false
    }
  },
  computed: {
    loginUser() {
      return this.$store.state.userInfo
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      getUserRcmd().then(resp => {
        if (resp && resp.code === 0) {
          this.modeEnabled = resp.data
        } else if (resp) {
          this.$message.warning(resp.msg)
        }
      })
    },
    handleLogin() {
      this.$router.push('/login')
    },
    goToSpace() {
      const userId = this.loginUser && (this.loginUser.userIdStr || this.loginUser.userId)
      if (userId) {
        this.$router.push(`/user/${userId}`)
      }
    },
    goToHistory() {
      this.$router.push('/my/history')
    },
    goToPlaylist() {
      this.$router.push('/my/fav')
    },
    goToWatchLater() {
      this.$router.push('/my/watch_later')
    },
    goToWallet() {
      this.$router.push('/my/wallet')
    },
    openSettings() {
      this.showSettingsDialog = true
    },
    onChange(value) {
      this.modeEnabled = value
      const payload = {
        mode: this.modeEnabled
      }
      setUserRcmd(payload).then(resp => {
        if (resp && resp.msg) {
          this.$message.warning(resp.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.my-page-container {
  height: 100%;
  background-color: #f4f5f7;
  padding-bottom: 30px;
  box-sizing: border-box; /* 确保 padding 不会撑大高度 */
  overflow-x: hidden;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

/* 未登录状态 */
.not-login-wrap {
  background-color: #ffffff;
  padding: 30px 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  cursor: pointer;

  .default-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f1f2f6;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #909399;
  }

  .login-tip {
    h3 {
      font-size: 16px;
      color: #212121;
      margin: 0 0 4px 0;
    }
    p {
      font-size: 12px;
      color: #999999;
      margin: 0;
    }
  }
}

/* 用户主资料卡片 */
.user-profile-header {
  background-color: #ffffff;
  padding: 12px 16px 16px 16px;

  .user-main-info {
    display: flex;
    align-items: center;
    padding: 10px 0 16px 0;
    cursor: pointer;

    .avatar {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 12px;
      border: 1px solid #eee;
    }

    .info-detail {
      flex: 1;

      .name-row {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 6px;

        .nickname {
          font-size: 16px;
          font-weight: bold;
          color: #212121;
        }

        .edit-icon {
          font-size: 14px;
          color: #999999;
        }

        .vip-tag {
          font-size: 10px;
          color: #fb7299;
          background-color: #fce4ec;
          padding: 1px 6px;
          border-radius: 4px;
        }
      }

      .coin-row {
        font-size: 12px;
        color: #999999;
        display: flex;
        align-items: center;
        gap: 6px;

        .divider {
          font-weight: bold;
        }
      }
    }

    .space-link {
      font-size: 13px;
      color: #999999;
      display: flex;
      align-items: center;
      gap: 2px;
    }
  }

  .stats-row {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-top: 10px;
    border-top: 1px solid #f4f4f4;

    .stat-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      flex: 1;

      .num {
        font-size: 16px;
        font-weight: bold;
        color: #212121;
        margin-bottom: 2px;
      }

      .label {
        font-size: 11px;
        color: #999999;
      }
    }

    .stat-divider {
      width: 1px;
      height: 16px;
      background-color: #e5e5e5;
    }
  }
}

/* 大会员横幅 */
.vip-banner-card {
  margin: 10px 12px;
  background: linear-gradient(135deg, #ffeef2 0%, #fff5f7 100%);
  border: 1px solid #fad2e1;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  .vip-left {
    display: flex;
    align-items: center;
    gap: 10px;

    .vip-icon-box {
      width: 28px;
      height: 28px;
      background-color: #fb7299;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      font-size: 16px;
    }

    .vip-text {
      h4 {
        font-size: 14px;
        color: #fb7299;
        margin: 0 0 2px 0;
        font-weight: bold;
      }
      p {
        font-size: 11px;
        color: #999999;
        margin: 0;
        display: flex;
        align-items: center;
      }
    }
  }

  .vip-right {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #fb7299;

    .open-btn {
      font-weight: 500;
    }
  }
}

/* 快捷功能网格 */
.quick-grid-section {
  background-color: #ffffff;
  margin: 0 12px 10px 12px;
  border-radius: 8px;
  display: flex;
  justify-content: space-around;
  padding: 16px 0;

  /* 当横幅隐藏时，增加顶部外边距，使布局间距自然协调 */
  &.no-banner-margin {
    margin-top: 10px;
  }

  .grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    cursor: pointer;

    i {
      font-size: 22px;
      color: #00a1d6;
    }

    span {
      font-size: 12px;
      color: #505050;
    }
  }
}

/* 更多服务列表 */
.more-service-section {
  background-color: #ffffff;
  margin: 0 12px;
  border-radius: 8px;
  padding: 12px 16px;

  .section-title {
    font-size: 14px;
    font-weight: bold;
    color: #212121;
    margin-bottom: 8px;
  }

  .service-list {
    .service-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid #f9f9f9;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }

      .item-left {
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 14px;
        color: #303133;

        i {
          font-size: 18px;
        }
      }

      .arrow {
        color: #c0c4cc;
        font-size: 14px;
      }
    }
  }
}

/* 弹窗内部样式 */
.setting-item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #303133;
  padding: 10px 0;
}
</style>

<style lang="scss">
.mobile-dialog {
  border-radius: 12px !important;
  max-width: 320px;
}
</style>
